import * as turf from "@turf/turf";

const SOURCE_ID = "title_tracts";
const LAYER_ID = "title_tracts";
const BORDER_HIGHLIGHT_LAYER_ID = "title_tracts_border_highlight";
const CLICKABLE_LAYERS = [LAYER_ID];
const UNIQUE_COLUMN = "id";

const STYLES = {
  "fill-outline-color": "#000000",
  "fill-color": "#7f888f",
  "fill-opacity": 0.3,
};

const BORDER_HIGHLIGHT_STYLES = {
  "line-color": "#000",
  "line-width": 3,
};

const ADD_BEFORE = "Laterals";

const addSource = (mapRef) => {
  if (!mapRef.current.getSource(SOURCE_ID)) {
    mapRef.current.addSource(SOURCE_ID, {
      type: "geojson",
      data: turf.featureCollection([]),
    });
  }
};

const addLayers = (mapRef) => {
  if (!mapRef.current.getLayer(LAYER_ID)) {
    mapRef.current.addLayer(
      {
        id: LAYER_ID,
        type: "fill",
        source: SOURCE_ID,
        layout: { visibility: "none" },
        paint: STYLES,
      },
      ADD_BEFORE
    );
  }

  if (!mapRef.current.getLayer(BORDER_HIGHLIGHT_LAYER_ID)) {
    mapRef.current.addLayer({
      id: BORDER_HIGHLIGHT_LAYER_ID,
      type: "line",
      source: SOURCE_ID,
      layout: {},
      paint: BORDER_HIGHLIGHT_STYLES,
      filter: ["in", UNIQUE_COLUMN, ""],
    });
  }
};

const addAll = (mapRef) => {
  addSource(mapRef);
  addLayers(mapRef);
};

const show = (mapRef) => {
  mapRef.current.setLayoutProperty(LAYER_ID, "visibility", "visible");
};

const setRows = (mapRef, rows) => {
  mapRef.current
    .getSource(SOURCE_ID)
    ?.setData(
      turf.featureCollection(
        rows
          .filter((row) => row.geom_polygon)
          .map((row) => turf.feature(row.geom_polygon, { id: row.id }))
      )
    );
};

export {
  SOURCE_ID,
  LAYER_ID,
  BORDER_HIGHLIGHT_LAYER_ID,
  CLICKABLE_LAYERS,
  UNIQUE_COLUMN,
  STYLES,
  BORDER_HIGHLIGHT_STYLES,
  addAll,
  show,
  setRows,
};
